import {Divider} from '@mui/material';
import Drawer from '@mui/material/Drawer';
import React from 'react';
import {SupportTicketModel} from '../../../../model/support/support-ticket.model';
import {useSupportTicketAttachmentDrawerState} from '../state/support-ticket-attachment-drawer-state';
import {SupportTicketAttachmentList} from './SupportTicketAttachmentList';
import {SupportTicketDrawerHeader} from './SupportTicketDrawerHeader';

export type Props = {
  isDrawerOpen: boolean
  onDrawerClosed: () => void

  ticket: SupportTicketModel
  translate: (key: string) => string
}

export const SupportTicketAttachmentDrawer = ({isDrawerOpen, onDrawerClosed, ticket, translate}: Props) => {
  const state = useSupportTicketAttachmentDrawerState(ticket.id)

  return <Drawer
    anchor="right"
    open={isDrawerOpen}
    onClose={onDrawerClosed}
    PaperProps={{
      sx: {
        width: '50%',
        marginTop: '64px',
        height: `calc(100% - 64px)`,
        position: 'fixed',
        right: 0,
        padding: 3,
        overflowY: 'auto',
      }
    }}
  >
    <SupportTicketDrawerHeader
      ticket={ticket}
      translate={translate}
    />
    <Divider sx={{ my: 2 }} />
    <SupportTicketAttachmentList
      attachments={state.attachments}
    />
  </Drawer>
}